module.exports = __webpack_public_path__ + "1994bcc1b3bc2807a6643174fc8dda39.svg";